import {  Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { restEndPoints } from './../../app.constants';
import { environment } from '../../../environment/environment';
import { DateConverterService } from '../../helpers/date-converter.service'
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  baseUrl = environment.apiHost;
  authToken: string | null = "";

  constructor(
    private httpClient: HttpClient,
    private dateConverterService: DateConverterService,
  ) {}

  // Method to get category counts with query parameters and headers
  getAllCategoryCounts(body: any): Observable<any> {
    const url = `${this.baseUrl}${restEndPoints.dashboard.getAllTiles}`;
    const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    };
    // Check and append parameters
    if (
      !payload.categoryIds ||
      !payload.startDate ||
      !payload.endDate ||
      !payload.companyId
    ) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }

  /**
   *
   * @param params for Charts in Dashboard
   * @returns
   */

  // Method to get lead fees counts with query parameters and headers
  getDashboardLeadFees(body: any): Observable<any> {
    const url = `${this.baseUrl}${restEndPoints.dashboard.getDashboardLeadFees}`;
    const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    };

    if (
      !payload.categoryIds ||
      !payload.startDate ||
      !payload.endDate ||
      !payload.companyId
    ) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }

  // Method to get bookings counts with query parameters and headers
  getDashboardBookings(body: any): Observable<any> {
    const url = `${this.baseUrl}${restEndPoints.dashboard.getDashboardBookings}`;
    const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    };

    // Check and append parameters
    if (
      !payload.categoryIds ||
      !payload.startDate ||
      !payload.endDate ||
      !payload.companyId
    ) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }

  // Method to get booking store counts with query parameters and headers
  getDashboardBookingsStore(body: any): Observable<any> {
    const url = `${this.baseUrl}${restEndPoints.dashboard.getDashboardBookingStore}`;
    const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    };
    if (
      !payload.categoryIds ||
      !payload.startDate ||
      !payload.endDate ||
      !payload.companyId
    ) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }

  // Method to get booking store percentage counts with query parameters and headers
  getDashboardBookingsStorePercent(body: any) {
    const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    };
    const url = `${this.baseUrl}${restEndPoints.dashboard.getDashboardBookingStorePercent}`;
    if (!payload.categoryIds) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }

  getLeebakkerdashboardBookingsCountPer(body: any) {
     const payload = {
      companyId: body.companyId,
      categoryIds: body.categoryIds,
      startDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.startDate,
      ),
      endDate: this.dateConverterService.getTimezoneAgnosticDateIsoString(
        body.endDate,
        true,
      ),
    }
    const url = `${this.baseUrl}${restEndPoints.dashboard.getLeebakkerdashboardBookingsCountPer}`;
    if (!payload.categoryIds) {
      return of(false);
    }

    // Make the GET request with headers and query params
    return this.httpClient.post(url, payload).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          return;
        }
      }),
    );
  }
}
